import { combineReducers } from "redux";
import { reducer as FormReducer } from "redux-form";
import { bannerReducer } from "./banner";
import { bannersReducer } from "./banners";
import { userReducer } from "./user";
import { retailersReducer } from "./retailers";
import { advertisersReducer } from "./advertisers";
import { currentAdvertiserReducer } from "./advertiser";
import { idReducer } from "./banner-id";
import { retailerReducer } from "./retailer";
import { modalReducer } from "./modal";
import { divClassRedcuer } from "./div-class";
import { searchReducer } from "./search";
import { pageReducer } from "./page";
import { errorReducer } from "./error";
import { templatesReducer } from "./templates";
import { templateReducer } from "./template";
import { fastrade } from "./fastrade";
import { adDataReducer } from "./ad-data";
import { adRequestReducer } from "./request";
import { skuSearchReducer } from "./sku-search";
import { rangeSearchReducer } from "./ranging";
import { productImageReducer } from "./product-image";
import { sizeToFitRedcuer } from "./size-to-fit";

const rootReducer = combineReducers({
  form: FormReducer,
  banner: bannerReducer,
  banners: bannersReducer,
  user: userReducer,
  retailers: retailersReducer,
  advertisers: advertisersReducer,
  currentAdvertiser: currentAdvertiserReducer,
  id: idReducer,
  retailer: retailerReducer,
  modal: modalReducer,
  divClass: divClassRedcuer,
  search: searchReducer,
  page: pageReducer,
  error: errorReducer,
  templates: templatesReducer,
  template: templateReducer,
  fastrade: fastrade,
  adData: adDataReducer,
  adRequest: adRequestReducer,
  skuSearch: skuSearchReducer,
  rangeSearch: rangeSearchReducer,
  productImage: productImageReducer,
  sizeToFit: sizeToFitRedcuer,
});

export default rootReducer;
